/* global window */
/* eslint prefer-template:0 */
/* eslint-disable sort-imports */

import _bindPolyfill from './lib/viewer/bindPolyfill.js'
import _isBot from './lib/common/isBot.js'
import _isSuspectedBot from './lib/common/isSuspectedBot.js' // This should be before the Polyfill

_bindPolyfill()
const isBot = _isBot(window)
const isSuspectedBot = _isSuspectedBot(window)

import {defineExperiment, experiment} from './lib/viewer/experiment.js'
import PackagesUtil from './lib/common/PackagesUtil.js'
import _convertSiteModel from './lib/viewer/convertSiteModel.js'
import _render from './lib/viewer/render.js'
import addExperimentsFromQuery from './lib/common/addExperimentsFromQuery.js'
import applyPackagesCache from './lib/common/applyPackagesCache.js'
import {getBaseVersion} from './lib/common/getBaseVersion.js'
import getFullRjsConfig from './lib/common/getFullRjsConfig.js'
import {getPageInfo} from './lib/viewer/utils.js'
import getQueryUtils from './lib/common/getQueryUtils.js'
import getSubdomain from './lib/common/getSubdomain.js'
import instruments from './lib/viewer/instruments.js'
import joinURL from './lib/common/joinURL.js'
import mobile from './lib/viewer/mobile.js'
import overrideScriptsLocationMapFromQuery from './lib/common/overrideScriptsLocationMapFromQuery.js'
import requirejs from 'requirejs'
import resourcePrefetch from './lib/viewer/resourcePrefetch.js'
import rjsConfig from './lib/viewer/rjs-config.js'
import storageUtil from './lib/common/storageUtil.js'

const options = require('json!./options/viewer.json')
const {rendererModel, publicModel, serviceTopology = {}} = window

window.persistent = storageUtil(window) // TODO: how is this used?
const queryUtil = getQueryUtils(window)
window.queryUtil = queryUtil

// Preload scripts for caching
const prefetch = window.isPrefetchMode ||
  window.location.pathname.indexOf('prefetch') > 0 ||
  queryUtil.isParameterTrue('prefetch')

const experimentInst = experiment(window)
const render = _render(window, requirejs, prefetch, isBot, experimentInst)
const packagesUtil = new PackagesUtil(options.packages, window.location.search, options.bundles)
const getViewerRjsConfig = rjsConfig(window, options.versions, experimentInst)
const {sendErrorOrQueue, instrument} = instruments(window, requirejs, isBot, isSuspectedBot, prefetch, experimentInst)
const convertSiteModel = _convertSiteModel(window, sendErrorOrQueue, queryUtil)
const isPreview = queryUtil.isParameterTrue('isEdited')
const isServerSide = !(window.clientSideRender || window.location.hash || isPreview)

const {wixBiSession = {}} = window
window.wixBiSession = wixBiSession
wixBiSession.mainLoaded = Date.now()
wixBiSession.et = 1

serviceTopology.scriptsLocationMap = overrideScriptsLocationMapFromQuery(serviceTopology.scriptsLocationMap, queryUtil.getParameterByName('scriptsLocations'))

rendererModel.runningExperiments = addExperimentsFromQuery(rendererModel.runningExperiments, queryUtil, 'viewer')

window.siteModel = convertSiteModel(rendererModel, publicModel, rendererModel.runningExperiments)
const {siteModel} = window

const pageInfo = publicModel && getPageInfo(window, publicModel.pageList)

instrument(serviceTopology, wixBiSession, queryUtil, siteModel, pageInfo)

if (publicModel && experimentInst.isOpen('checkRenderTime') && !options.disableCheckRenderTime) {
  if (Math.abs(Date.now() - publicModel.renderTime) > 2592e5) {
    wixBiSession.sendError({
      errorName: 'Error #2592e5',
      errorCode: 111026
    })
    throw new Error('Error #2592e5')
  }
}

if (window.karmaIntegration) {
  siteModel.documentServicesModel = siteModel.documentServicesModel || window.karmaIntegration.documentServicesModel
  siteModel.wixapps = siteModel.wixapps || {}
  siteModel.wixapps.appbuilder = siteModel.wixapps.appbuilder || {}
  siteModel.wixapps.appbuilder.descriptor = siteModel.wixapps.appbuilder.descriptor || {}
  siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion = siteModel.wixapps.appbuilder.descriptor.applicationInstanceVersion || {}
}

const config = getFullRjsConfig(
  'santa',
  window.santaBase,
  getViewerRjsConfig(serviceTopology),
  packagesUtil,
  serviceTopology
)

if (!options.disablePackagesCache) {
  applyPackagesCache({
    proj: 'santa',
    paths: config.paths,
    manifest: options.manifest,
    version: options.version,
    scriptsDomainUrl: serviceTopology.scriptsDomainUrl
  })
}

siteModel.santaBase = config.baseUrl
serviceTopology.staticServerFallbackUrl = serviceTopology.staticServerFallbackUrl || 'https://fallback.wix.com/'
siteModel.baseVersion = getBaseVersion(siteModel.santaBase)
siteModel.santaBaseFallbackUrl = siteModel.baseVersion ? joinURL(serviceTopology.staticServerFallbackUrl, siteModel.baseVersion) : null

requirejs.config(config)
defineExperiment(window)

const mobileView = mobile.isMobileView(window, siteModel, queryUtil)

let contentCache = function () {} //eslint-disable-line func-style
const dynamicModel = null
if (publicModel && !queryUtil.isParameterTrue('prefetch')) {
  const resourcePrefetchOptions = {
    siteModel,
    publicModel,
    pageInfo,
    shouldTimeout: experimentInst.isOpen('pageRequestTimeout'),
    wixBiSession,
    dynamicModel,
    isServerSide,
    mobileView,
    experiment: experimentInst,
    requirejs
  }
  contentCache = resourcePrefetch(window, resourcePrefetchOptions)
}

try {
  window.document.domain = getSubdomain(window.document.domain)
} catch (e) {
  // empty
}

window.isPreview = queryUtil.isParameterTrue.bind(null, 'isEdited')
const isExternalPreview = rendererModel.previewMode

render(isServerSide, isPreview, isExternalPreview, contentCache, queryUtil, siteModel, wixBiSession, mobileView, pageInfo, config)
wixBiSession.beat(4)



// WEBPACK FOOTER //
// ./~/santa-main-r/src/viewer.js